module.exports = __webpack_public_path__ + "img/202108.99b6aee3.png";